import React from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import { useAuthContext } from './contexts/AuthContext';

const PrivateRoute = ({ children, ...rest }) => {
    const location = useLocation();
    const { auth } = useAuthContext();
    if (!auth.ready) {
        return '... checking key ...';
    }
    return (
        <Route {...rest}>
            {auth.isAuthenticated === true ? (
                children
            ) : (
                <Redirect to={{ pathname: '/', state: { from: location } }} />
            )}
        </Route>
    );
};

export default PrivateRoute;
